import * as React from "react";
const SvgChevron = props => <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M5.5 8.25L11 13.75L16.5 8.25" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" style={{
    vectorEffect: "inherit"
  }} /></svg>;
export default SvgChevron;